export default {
  "AgreementCardAdvertising.CardName": "広告目的でのIPアドレス利用",
  "AgreementCardAdvertising.CardDetail":
    "ドコモがお客さまの趣味趣向に応じて推奨する「ドコモ広告」の表示や、ドコモの広告計測タグを設置したドコモまたは他社のサイト・アプリでの広告閲覧状況等の確認のため、通信時にドコモが発行するお客さまのIPアドレスによりお客さまを識別のうえ、広告専用IDを生成し利用させていただきます",
}
